import { FC, useState } from 'react';
import { Lead, PersonalLead } from 'models/Lead';
import { LeadCard } from 'pages/Campaign/components/Leads/components';
import { BlockUI, Button, SkeletonCard } from 'components';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

import './LeadHeader.styles.scss';
import classNames from 'classnames';
import { isLeadPersonal } from 'utils/lead';
import PersonalLeadCard from 'pages/Campaign/components/Leads/components/PersonalLeadCard';

type LeadHeaderProps = {
  lead: Lead | PersonalLead;
  isLoading: boolean;
};

const LeadHeader: FC<LeadHeaderProps> = (props) => {
  const { lead, isLoading } = props;
  const isPersonalLead = isLeadPersonal(lead);

  const [headerExpanded, setHeaderExpanded] = useState(false);

  return (
    <div
      className={classNames('lead-header', {
        'lead-header--expanded': headerExpanded,
      })}
    >
      <div className="lead-header__content">
        <BlockUI
          loading={isLoading}
          loadingElement={<SkeletonCard className="lead-header__skeleton" />}
        >
          {isPersonalLead ? (
            <PersonalLeadCard lead={lead} showFooter={false} />
          ) : (
            <LeadCard lead={lead} hasLink={false} />
          )}

          {!isPersonalLead && (
            <Button
              variant="link"
              onClick={() => setHeaderExpanded((prev) => !prev)}
              className="lead-header__expand-button"
            >
              {headerExpanded ? (
                <>
                  Show less
                  <span className="lead-header__arrows">
                    <FiChevronUp />
                    <FiChevronUp />
                  </span>
                </>
              ) : (
                <>
                  Show more
                  <span className="lead-header__arrows">
                    <FiChevronDown />
                    <FiChevronDown />
                  </span>
                </>
              )}
            </Button>
          )}
        </BlockUI>
      </div>
    </div>
  );
};

export default LeadHeader;
